// Where "this guide is complete" is stored.
//
// Placeholder until BE decides how completion is persisted (per user or per
// account, and the endpoint): it is kept in localStorage per account so the
// flow can be built and tried now. Only these two functions know about the
// storage, so BE's answer replaces this file and nothing else.
const storageKey = accountId => `onboarding_guide_completed_${accountId}`;

/**
 * @param {number|string} accountId
 * @returns {string[]} ids of the guides marked complete for the account
 */
export const readCompletedGuides = accountId => {
  try {
    const parsed = JSON.parse(
      window.localStorage.getItem(storageKey(accountId)) || '[]'
    );
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

/**
 * Takes a guide back to not complete (the list's Undo). Resolves to false when
 * it could not be stored.
 */
export const removeGuideCompletion = ({ accountId, guideId }) => {
  try {
    window.localStorage.setItem(
      storageKey(accountId),
      JSON.stringify(
        readCompletedGuides(accountId).filter(id => id !== guideId)
      )
    );
    return true;
  } catch {
    return false;
  }
};

/**
 * Marks a guide complete. Resolves to false when it could not be stored
 * (storage blocked), so the caller can keep the user's prompt open.
 */
export const saveGuideCompletion = ({ accountId, guideId }) => {
  try {
    const completed = readCompletedGuides(accountId);
    if (!completed.includes(guideId)) completed.push(guideId);
    window.localStorage.setItem(
      storageKey(accountId),
      JSON.stringify(completed)
    );
    return true;
  } catch {
    return false;
  }
};
